<template>
  <div class="helpCenter_appboxfm">
    <v-toolbar dense flat width="500px">
      <v-toolbar-title class="secondary--text font-weight-bold"
        >Centro de Ayuda
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <SvgIcon
        height="40"
        width="40"
        class="secondary--text mr-5"
        iconType="icon_help_center"
      />
    </v-toolbar>
    <v-divider></v-divider>
    <v-simple-table dense class="px-0 mx-0">
      <template v-slot:default>
        <tbody>
          <template v-for="(item, index) in codCountry[countryProperty].items">
            <tr v-if="getVideosByApp(item.showByApp)" :key="index">
              <td>
                <span class="secondary--text font-weight-bold body-1">
                  {{ item.titulo }}
                </span>
                <span class="lightGreyBlue--text">{{ item.descripcion }}</span>
              </td>

              <td>
                <v-dialog v-model="dialog[index]" width="857">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" :id="generateId(item.titulo)">
                      <SvgIcon
                        height="24"
                        width="24"
                        class="tertiary--text"
                        iconType="icon_play"
                      />
                    </v-btn>
                  </template>
                  <iframe
                    style="border:none;"
                    width="842"
                    height="546"
                    :src="getUrl(item.videoId)"
                    frameborder="0"
                  >
                  </iframe>
                </v-dialog>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import { SvgIcon } from '@leapsight/styleguide'

export default {
  name: 'helpCenterAppBox',
  components: {
    SvgIcon
  },
  data: () => ({
    codCountry: {
      ar: {
        items: [
          {
            titulo: 'Alta De Personas:',
            descripcion: '¿Cómo asignarles roles y perfil?',
            videoId: 'NdCZwh4r3kY',
            play: false,
            showByApp: {
              fm: true,
              portal: true,
              lt: false
            }
          },
          {
            titulo: 'Alta De Zonas:',
            descripcion: '¿Cómo configurar distintos tipos de zonas?',
            videoId: '_uU7rtLN8s8',
            play: false,
            showByApp: {
              fm: true,
              portal: true,
              lt: false
            }
          },
          {
            titulo: 'Alta De Eventos:',
            descripcion:
              '¿Cómo configurar los distintos tipos y combinaciones de eventos?',
            videoId: 'fovkyX-qs1E',
            play: false,
            showByApp: {
              fm: true,
              portal: true,
              lt: false
            }
          },
          {
            titulo: 'Ingreso, Navegación, y Visualización:',
            descripcion:
              '¿Cuáles son las opciones de visualización de mapa y entidades?',
            videoId: 'MnuGUodYPvI',
            play: false,
            showByApp: {
              fm: false,
              portal: true,
              lt: true
            }
          },
          {
            titulo: 'Markers:',
            descripcion: '¿Cómo funcionan y qué información podemos obtener?',
            videoId: 'Zb0e4xML3mY',
            play: false,
            showByApp: {
              fm: false,
              portal: true,
              lt: true
            }
          },
          {
            titulo: 'Listado De Entidades:',
            descripcion: '¿Qué son y qué puedo gestionar?',
            videoId: 'VmqpSe5WorE',
            play: false,
            showByApp: {
              fm: false,
              portal: true,
              lt: true
            }
          },
          {
            titulo: 'Grilla De Recorridos:',
            descripcion: '¿Qué información brinda y cómo operar?',
            videoId: 'Y5e9Dooa7Cw',
            play: false,
            showByApp: {
              fm: false,
              portal: true,
              lt: true
            }
          },
          {
            titulo: 'Certificados:',
            descripcion: '¿Qué son, para qué sirven, y cómo obtenerlos?',
            videoId: 'kZ7sOlnrtmU',
            play: false,
            showByApp: {
              fm: false,
              portal: true,
              lt: true
            }
          }
        ]
      },
      cl: {
        items: [
          {
            titulo: 'Alta De Personas:',
            descripcion: '¿Cómo asignarles roles y perfil?',
            videoId: 'NdCZwh4r3kY',
            play: false,
            showByApp: {
              fm: true,
              portal: true,
              lt: false
            }
          },
          {
            titulo: 'Alta De Zonas:',
            descripcion: '¿Cómo configurar distintos tipos de zonas?',
            videoId: 'N6JX8T00zCI',
            play: false,
            showByApp: {
              fm: true,
              portal: true,
              lt: false
            }
          },
          {
            titulo: 'Alta De Eventos:',
            descripcion:
              '¿Cómo configurar los distintos tipos y combinaciones de eventos?',
            videoId: 'fovkyX-qs1E',
            play: false,
            showByApp: {
              fm: true,
              portal: true,
              lt: false
            }
          },
          {
            titulo: 'Ingreso, Navegación, y Visualización:',
            descripcion:
              '¿Cuáles son las opciones de visualización de mapa y entidades?',
            videoId: 'VQQATDmmHTo',
            play: false,
            showByApp: {
              fm: false,
              portal: true,
              lt: true
            }
          },
          {
            titulo: 'Markers:',
            descripcion: '¿Cómo funcionan y qué información puedes obtener?',
            videoId: 'SJSf1mlgkdY',
            play: false,
            showByApp: {
              fm: false,
              portal: true,
              lt: true
            }
          },
          {
            titulo: 'Listado De Entidades:',
            descripcion: '¿Qué son y qué puedo gestionar?',
            videoId: 'Bsgc-UALrfo',
            play: false,
            showByApp: {
              fm: false,
              portal: true,
              lt: true
            }
          },
          {
            titulo: 'Grilla De Recorridos:',
            descripcion: '¿Qué información brinda y cómo operar?',
            videoId: 'T01-x6n67Bo',
            play: false,
            showByApp: {
              fm: false,
              portal: true,
              lt: true
            }
          },
          {
            titulo: 'Certificados:',
            descripcion: '¿Qué son, para qué sirven, y cómo obtenerlos?',
            videoId: 'awnm2ZnVbK0',
            play: false,
            showByApp: {
              fm: false,
              portal: true,
              lt: true
            }
          }
        ]
      },
      uy: {
        items: [
          {
            titulo: 'Alta De Personas:',
            descripcion: '¿Cómo asignarles roles y perfil?',
            videoId: 'NdCZwh4r3kY',
            play: false,
            showByApp: {
              fm: true,
              portal: true,
              lt: false
            }
          },
          {
            titulo: 'Alta De Zonas:',
            descripcion: '¿Cómo configurar distintos tipos de zonas?',
            videoId: 'wOosxkeDmWM',
            play: false,
            showByApp: {
              fm: true,
              portal: true,
              lt: false
            }
          },
          {
            titulo: 'Alta De Eventos:',
            descripcion:
              '¿Cómo configurar los distintos tipos y combinaciones de eventos?',
            videoId: 'fovkyX-qs1E',
            play: false,
            showByApp: {
              fm: true,
              portal: true,
              lt: false
            }
          },
          {
            titulo: 'Ingreso, Navegación, y Visualización:',
            descripcion:
              '¿Cuáles son las opciones de visualización de mapa y entidades?',
            videoId: 'IOoAV_9qgCU',
            play: false,
            showByApp: {
              fm: false,
              portal: true,
              lt: true
            }
          },
          {
            titulo: 'Markers:',
            descripcion: '¿Cómo funcionan y qué información podemos obtener?',
            videoId: 'hgNmhnJnWbU',
            play: false,
            showByApp: {
              fm: false,
              portal: true,
              lt: true
            }
          },
          {
            titulo: 'Listado De Entidades:',
            descripcion: '¿Qué son y qué puedo gestionar?',
            videoId: 'ZeGCvcqZFrw',
            play: false,
            showByApp: {
              fm: false,
              portal: true,
              lt: true
            }
          },
          {
            titulo: 'Grilla De Recorridos:',
            descripcion: '¿Qué información brinda y cómo operar?',
            videoId: 'B_fBxBhgCqQ',
            play: false,
            showByApp: {
              fm: false,
              portal: true,
              lt: true
            }
          },
          {
            titulo: 'Certificados:',
            descripcion: '¿Qué son, para qué sirven, y cómo obtenerlos?',
            videoId: 'yPe2jNyRjfk',
            play: false,
            showByApp: {
              fm: false,
              portal: true,
              lt: true
            }
          }
        ]
      }
    },
    dialog: [false, false, false, false, false, false, false, false, false],
    country: ''
  }),
  methods: {
    getUrl(videoId) {
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`
    },
    testPrefix(string, regex) {
      return regex.test(string)
    },
    getVideosByApp(showByApp) {
      if (this.testPrefix(this.$route.path, /^\/fleet-management\.*/))
        return showByApp.fm

      if (this.testPrefix(this.$route.path, /^\/portal\.*/))
        return showByApp.portal

      if (this.testPrefix(this.$route.path, /^\/live-tracking\.*/))
        return showByApp.lt
    },
    generateId(titulo) {
      return 'idBtnAyuda' + titulo
        .normalize('NFD') // Normalizar los caracteres Unicode para separar las tildes
        .replace(/[\u0300-\u036f]/g, '') // Remover las tildes
        .replace(/,/g, '') // Eliminar comas
        .replace(/ y /gi, '') // Eliminar " y " (con espacios a los lados)
        .replace(/\s+/g, '') // Eliminar todos los espacios
        .replace(/[^a-zA-Z0-9]/g, ''); // Eliminar cualquier otro carácter no alfanumérico
    }
  },
  computed: {
    countryProperty() {
      this.country = localStorage.getItem('country_id')
      return this.country
    }
  }
}
</script>

<style scoped>
.helpCenter_appboxfm {
  position: absolute;
  right: -12px;
  top: 60px;
}
.helpCenter_appboxfm:after,
.helpCenter_appboxfm:before {
  bottom: 100%;
  right: 16px;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.helpCenter_appboxfm:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #ffffff;
  border-width: 14px;
  margin-left: -30px;
}
.helpCenter_appboxfm:before {
  border-color: rgba(213, 213, 213, 0);
  border-bottom-color: #d5d5d5;
  border-width: 15px;
  margin-left: -31px;
}

.helpCenter_appboxfm .pill .pill--name {
  font-size: 0.7rem;
}
.v-toolbar__content {
  padding-right: 0;
}
.v-data-table__wrapper {
  padding-left: 10px;
  padding-right: 0px;
}
</style>
